import SingleBlog from '../../../../components/mui5/resourcepage/article/SingleBlog';
import {
  fetchAllCatgory,
  fetchAllTags,
  fetchPostSingle,
  fetchPostListByCatgory,
} from '../../../features/resource/resourceApi';
import { getObjFrmArray } from '../../../../commons/utils/utils';
import { config } from '../../../../config';
import Custom404 from '../../404';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function Index({
  categories,
  tags,
  currentPost,
  relatedBlogs,
  isError,
  isServerError,
  extraMeta,
}) {
  const router = useRouter();
  useEffect(() => {
    if (isServerError) router.push('/something-went-wrong');
  }, [isServerError]);

  return isError ? (
    <Custom404 />
  ) : (
    <SingleBlog
      categories={categories}
      tags={tags}
      currentPost={currentPost}
      relatedBlogs={relatedBlogs}
      extraMeta={extraMeta}
    />
  );
}

export async function getServerSideProps(context) {
  const { page, category, blog } = context.query;
  const domain = context.req.headers.host;
  try {
    const categories = await fetchAllCatgory();
    const tags = await fetchAllTags();
    const currentPost = await fetchPostSingle(blog);
    const relatedBlogs = await fetchPostListByCatgory({
      category: getObjFrmArray(categories, 'slug', category)?.id,
      pageNo: page ? page : 1,
      pageItemCount: config.resources.item_per_page,
    });
    return {
      props: {
        categories: categories,
        tags: tags,
        currentPost: currentPost.length != 0 && currentPost[0],
        relatedBlogs: relatedBlogs.posts,
        isError:
          currentPost.length == 0 ||
          typeof getObjFrmArray(categories, 'slug', category)?.id ==
            'undefined',
        extraMeta: {
          ogUrl: `${config.SiteURL}resources/${
            getObjFrmArray(categories, 'slug', category)?.slug
          }/${currentPost.length != 0 && currentPost[0].slug}`,
        },
      },
    };
  } catch (err) {
    return {
      props: {
        isServerError: true,
      },
    };
  }
}
